import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { TiTick } from 'react-icons/ti';
import PropTypes from 'prop-types';

const PasswordRules = ({ password }) => {
  const rules = [
    { label: 'Minimum 8 characters', test: password.length >= 8 },
    { label: 'At least 1 uppercase letter', test: /[A-Z]/.test(password) },
    { label: 'At least 1 lowercase letter', test: /[a-z]/.test(password) },
    { label: 'At least 1 number', test: /[0-9]/.test(password) },
    {
      label: 'At least 1 special character',
      test: /[@$!%*?&#^()_\-+={}[\]|:;"'<>,./~`]/.test(password),
    },
  ];

  const allValid = rules.every((rule) => rule.test);

  if (allValid) return null;

  return (
    <ul className="password-rules">
      {rules.map((rule, idx) => (
        <li key={idx} className={rule.test ? 'valid' : 'invalid'}>
          {rule.test ? <TiTick color="#0f9b72" /> : <RxCross2 color="#BD210B" />} {rule.label}
        </li>
      ))}
    </ul>
  );
};
PasswordRules.propTypes = {
  password: PropTypes.string.isRequired,
};

export default PasswordRules;
